import { SelfServiceAPI } from 'types';

const mapPointsClubTierProp = (pointsClubTier: SelfServiceAPI.PointsClubTier) => {
  switch (pointsClubTier) {
    case 'POINTS_CLUB':
      return 'base';
    case 'POINTS_CLUB_PLUS':
      return 'plus';
    default:
      return '';
  }
};

export default mapPointsClubTierProp;
